import React from 'react';
import PropTypes from 'prop-types';
import { PaginationItem, PaginationLink } from 'reactstrap';

const PageNext = ({ pagination, sheetsPerPage, dispatch, types, onSelected }) => {
    let pageMaxSection = Math.ceil(pagination.totalPage / sheetsPerPage);
    let pageCurrentSection = Math.ceil(pagination.currentPage / sheetsPerPage);

    if (pageMaxSection === pageCurrentSection) {
        return (
            <PaginationItem disabled>
                <PaginationLink next />
            </PaginationItem>
        );
    }
    return (
        <PaginationItem>
            <PaginationLink
                next
                onClick={() => {
                    if (dispatch && types)
                        // dispatch(action(pageCurrentSection * pgsNo + 1))
                        dispatch({ type: types, payload: pageCurrentSection * sheetsPerPage + 1 })
                        //  dispatch({ type: "LOGS_PAGE_CHANGE", payload: type })
                    else
                        onSelected(pageCurrentSection * sheetsPerPage + 1)
                }}
            />
        </PaginationItem>
    );
};

PageNext.propTypes = {
    pagination: PropTypes.object,
    sheetsPerPage: PropTypes.number,
    dispatch: PropTypes.func,
    types: PropTypes.string,
    onSelected: PropTypes.func
};

export default PageNext;
